const dataByArea = [
  {
    id: '10180',
    abbState: 'TX',
    state: 'Texas',
    name: 'Abilene',
    job: '1.4',
    yoyChange: '16.4',
    medianPrice: '251,000',
    hai: '99.3',
    growth: '7.7'
  },
  {
    id: '10420',
    abbState: 'OH',
    state: 'Ohio',
    name: 'Akron',
    job: '5.7',
    yoyChange: '14.2',
    medianPrice: '215,500',
    hai: '168.3',
    growth: '-0.2'
  },
  {
    id: '10580',
    abbState: 'NY',
    state: 'New York',
    name: 'Albany-Schenectady-Troy',
    job: '6.1',
    yoyChange: '8.2',
    medianPrice: '295,400',
    hai: '144.0',
    growth: '3.2'
  },
  {
    id: '10740',
    abbState: 'NM',
    state: 'New Mexico',
    name: 'Albuquerque',
    job: '2.3',
    yoyChange: '13.7',
    medianPrice: '339,500',
    hai: '94.8',
    growth: '2.5'
  },
  {
    id: '10900',
    abbState: 'PA, NJ',
    state: 'Pennsylvania, New Jersey',
    name: 'Allentown-Bethlehem-Easton',
    job: '9.7',
    yoyChange: '12.6',
    medianPrice: '314,800',
    hai: '118.6',
    growth: '4.9'
  },
  {
    id: '11100',
    abbState: 'TX',
    state: 'Texas',
    name: 'Amarillo',
    job: '2.1',
    yoyChange: '7.4',
    medianPrice: '224,000',
    hai: '146.7',
    growth: '6.1'
  },
  {
    id: '11460',
    abbState: 'MI',
    state: 'Michigan',
    name: 'Ann Arbor',
    job: '10.2',
    yoyChange: '5.3',
    medianPrice: '377,200',
    hai: '125.5',
    growth: '6.2'
  },
  {
    id: '11540',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Appleton',
    job: '5.7',
    yoyChange: '7.5',
    medianPrice: '272,300',
    hai: '146.2',
    growth: '7.3'
  },
  {
    id: '12060',
    abbState: 'GA',
    state: 'Georgia',
    name: 'Atlanta-Sandy Springs-Marietta',
    job: '5.6',
    yoyChange: '14.0',
    medianPrice: '371,200',
    hai: '103.6',
    growth: '14.5'
  },
  {
    id: '12100',
    abbState: 'NJ',
    state: 'New Jersey',
    name: 'Atlantic City-Hammonton',
    job: '20.3',
    yoyChange: '8.6',
    medianPrice: '321,700',
    hai: '120.2',
    growth: '0.2'
  },
  {
    id: '12420',
    abbState: 'TX',
    state: 'Texas',
    name: 'Austin-Round Rock',
    job: '2.6',
    yoyChange: '8.7',
    medianPrice: '541,600',
    hai: '87.1',
    growth: '31.9'
  },
  {
    id: '12580',
    abbState: 'MD',
    state: 'Maryland',
    name: 'Baltimore-Columbia-Towson',
    job: '12.0',
    yoyChange: '5.5',
    medianPrice: '390,600',
    hai: '116.1',
    growth: '4.0'
  },
  {
    id: '12700',
    abbState: 'MA',
    state: 'Massachusetts',
    name: 'Barnstable Town',
    job: '2.7',
    yoyChange: '11.1',
    medianPrice: '684,200',
    hai: '68.1',
    growth: '7.7'
  },
  {
    id: '12940',
    abbState: 'LA',
    state: 'Louisiana',
    name: 'Baton Rouge',
    job: '0.7',
    yoyChange: '6.3',
    medianPrice: '271,600',
    hai: '107.3',
    growth: '7.9'
  },
  {
    id: '13140',
    abbState: 'TX',
    state: 'Texas',
    name: 'Beaumont-Port Arthur',
    job: '5.2',
    yoyChange: '5.4',
    medianPrice: '214,000',
    hai: '153.8',
    growth: '1.3'
  },
  {
    id: '13820',
    abbState: 'AL',
    state: 'Alabama',
    name: 'Birmingham-Hoover',
    job: '4.6',
    yoyChange: '12.6',
    medianPrice: '308,000',
    hai: '107.2',
    growth: '-1.6'
  },
  {
    id: '13900',
    abbState: 'ND',
    state: 'North Dakota',
    name: 'Bismarck',
    job: '2.5',
    yoyChange: '-4.1',
    medianPrice: '270,100',
    hai: '157.9',
    growth: '20.9'
  },
  {
    id: '14010',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Bloomington',
    job: '14.2',
    yoyChange: '9.3',
    medianPrice: '217,700',
    hai: '209.5',
    growth: '0.2'
  },
  {
    id: '14260',
    abbState: 'ID',
    state: 'Idaho',
    name: 'Boise City-Nampa',
    job: '1.5',
    yoyChange: '0.6',
    medianPrice: '483,800',
    hai: '78.4',
    growth: '27.8'
  },
  {
    id: '14460',
    abbState: 'MA, NH',
    state: 'Massachusetts, New Hampshire',
    name: 'Boston-Cambridge-Newton',
    job: '20.4',
    yoyChange: '6.2',
    medianPrice: '698,900',
    hai: '76.4',
    growth: '6.7'
  },
  {
    id: '14500',
    abbState: 'CO',
    state: 'Colorado',
    name: 'Boulder',
    job: '14.6',
    yoyChange: '7.5',
    medianPrice: '826,900',
    hai: '66.2',
    growth: '10.1'
  },
  {
    id: '14540',
    abbState: 'KY',
    state: 'Kentucky',
    name: 'Bowling Green',
    job: '2.2',
    yoyChange: '13.4',
    medianPrice: '260,900',
    hai: '111.5',
    growth: '45.0'
  },
  {
    id: '14860',
    abbState: 'CT',
    state: 'Connecticut',
    name: 'Bridgeport-Stamford-Norwalk',
    job: '15.0',
    yoyChange: '4.3',
    medianPrice: '687,000',
    hai: '76.9',
    growth: '3.7'
  },
  {
    id: '15380',
    abbState: 'NY',
    state: 'New York',
    name: 'Buffalo-Cheektowaga-Niagara Falls',
    job: '16.4',
    yoyChange: '5.2',
    medianPrice: '243,800',
    hai: '147.9',
    growth: '2.5'
  },
  {
    id: '15540',
    abbState: 'VT',
    state: 'Vermont',
    name: 'Burlington-South Burlington',
    job: '11.4',
    yoyChange: '10.6',
    medianPrice: '453,700',
    hai: '101.4',
    growth: '6.1'
  },
  {
    id: '15940',
    abbState: 'OH',
    state: 'Ohio',
    name: 'Canton-Massillon',
    job: '6.5',
    yoyChange: '3.4',
    medianPrice: '181,300',
    hai: '177.1',
    growth: '-1.3'
  },
  {
    id: '15980',
    abbState: 'FL',
    state: 'Florida',
    name: 'Cape Coral-Fort Myers',
    job: '0.9',
    yoyChange: '16.7',
    medianPrice: '420,000',
    hai: '76.0',
    growth: '24.8'
  },
  {
    id: '16300',
    abbState: 'IA',
    state: 'Iowa',
    name: 'Cedar Rapids',
    job: '4.3',
    yoyChange: '11.1',
    medianPrice: '207,700',
    hai: '170.1',
    growth: '5.7'
  },
  {
    id: '16580',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Champaign-Urbana',
    job: '1.7',
    yoyChange: '7.2',
    medianPrice: '200,400',
    hai: '191.1',
    growth: '-4.0'
  },
  {
    id: '16700',
    abbState: 'SC',
    state: 'South Carolina',
    name: 'Charleston-North Charleston',
    job: '4.1',
    yoyChange: '11.1',
    medianPrice: '416,800',
    hai: '91.6',
    growth: '19.2'
  },
  {
    id: '16620',
    abbState: 'WV',
    state: 'West Virginia',
    name: 'Charleston',
    job: '7.5',
    yoyChange: '2.3',
    medianPrice: '171,800',
    hai: '157.3',
    growth: '-16.9'
  },
  {
    id: '16740',
    abbState: 'NC, SC',
    state: 'North Carolina, South Carolina',
    name: 'Charlotte-Concord-Gastonia',
    job: '3.7',
    yoyChange: '10.2',
    medianPrice: '400,600',
    hai: '91.5',
    growth: '50.4'
  },
  {
    id: '16860',
    abbState: 'TN, GA',
    state: 'Tennessee, Georgia',
    name: 'Chattanooga',
    job: '2.1',
    yoyChange: '13.2',
    medianPrice: '293,600',
    hai: '123.3',
    growth: '7.2'
  },
  {
    id: '16980',
    abbState: 'IL, IN, WI',
    state: 'Illinois, Indiana, Wisconsin',
    name: 'Chicago-Naperville-Elgin',
    job: '19.5',
    yoyChange: '3.4',
    medianPrice: '349,400',
    hai: '115.6',
    growth: '0.1'
  },
  {
    id: '17140',
    abbState: 'OH, KY, IN',
    state: 'Ohio, Kentucky, Indiana',
    name: 'Cincinnati',
    job: '3.4',
    yoyChange: '5.9',
    medianPrice: '268,400',
    hai: '147.0',
    growth: '5.8'
  },
  {
    id: '17460',
    abbState: 'OH',
    state: 'Ohio',
    name: 'Cleveland-Elyria',
    job: '8.1',
    yoyChange: '7.0',
    medianPrice: '227,700',
    hai: '154.1',
    growth: '0.4'
  },
  {
    id: '17820',
    abbState: 'CO',
    state: 'Colorado',
    name: 'Colorado Springs',
    job: '2.4',
    yoyChange: '4.8',
    medianPrice: '462,200',
    hai: '87.2',
    growth: '15.5'
  },
  {
    id: '17860',
    abbState: 'MO',
    state: 'Missouri',
    name: 'Columbia',
    job: '3.4',
    yoyChange: '10.3',
    medianPrice: '287,600',
    hai: '138.1',
    growth: '21.6'
  },
  {
    id: '17900',
    abbState: 'SC',
    state: 'South Carolina',
    name: 'Columbia',
    job: '1.6',
    yoyChange: '17.0',
    medianPrice: '278,000',
    hai: '110.3',
    growth: '7.8'
  },
  {
    id: '18140',
    abbState: 'OH',
    state: 'Ohio',
    name: 'Columbus',
    job: '4.3',
    yoyChange: '9.0',
    medianPrice: '312,100',
    hai: '121.3',
    growth: '15.7'
  },
  {
    id: '18580',
    abbState: 'TX',
    state: 'Texas',
    name: 'Corpus Christi',
    job: '3.6',
    yoyChange: '11.4',
    medianPrice: '281,000',
    hai: '104.0',
    growth: '-2.0'
  },
  {
    id: '18880',
    abbState: 'FL',
    state: 'Florida',
    name: 'Crestview-Fort Walton Beach-Destin',
    job: '1.2',
    yoyChange: '9.4',
    medianPrice: '413,700',
    hai: '88.3',
    growth: '59.9'
  },
  {
    id: '19060',
    abbState: 'MD, WV',
    state: 'Maryland, West Virginia',
    name: 'Cumberland',
    job: '1.7',
    yoyChange: '-4.5',
    medianPrice: '136,600',
    hai: '265.4',
    growth: '-8.1'
  },
  {
    id: '19100',
    abbState: 'TX',
    state: 'Texas',
    name: 'Dallas-Fort Worth-Arlington',
    job: '5.6',
    yoyChange: '13.0',
    medianPrice: '390,100',
    hai: '95.6',
    growth: '18.9'
  },
  {
    id: '19340',
    abbState: 'IA, IL',
    state: 'Iowa, Illinois',
    name: 'Davenport-Moline-Rock Island',
    job: '20.3',
    yoyChange: '8.7',
    medianPrice: '172,000',
    hai: '196.6',
    growth: '0.5'
  },
  {
    id: '19460',
    abbState: 'AL',
    state: 'Alabama',
    name: 'Decatur',
    job: '4.2',
    yoyChange: '9.6',
    medianPrice: '240,500',
    hai: '139.5',
    growth: '1.7'
  },
  {
    id: '19500',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Decatur',
    job: '56.3',
    yoyChange: '4.8',
    medianPrice: '122,700',
    hai: '247.4',
    growth: '-7.5'
  },
  {
    id: '19660',
    abbState: 'FL',
    state: 'Florida',
    name: 'Deltona-Daytona Beach-Ormond Beach',
    job: '1.4',
    yoyChange: '19.6',
    medianPrice: '358,900',
    hai: '82.3',
    growth: '38.5'
  },
  {
    id: '19740',
    abbState: 'CO',
    state: 'Colorado',
    name: 'Denver-Aurora-Lakewood',
    job: '5.6',
    yoyChange: '8.3',
    medianPrice: '666,000',
    hai: '71.6',
    growth: '14.3'
  },
  {
    id: '19780',
    abbState: 'IA',
    state: 'Iowa',
    name: 'Des Moines-West Des Moines',
    job: '1.7',
    yoyChange: '6.0',
    medianPrice: '281,700',
    hai: '144.5',
    growth: '24.3'
  },
  {
    id: '19820',
    abbState: 'MI',
    state: 'Michigan',
    name: 'Detroit-Warren-Deaborn',
    job: '10.9',
    yoyChange: '2.5',
    medianPrice: '266,000',
    hai: '132.8',
    growth: '1.9'
  },
  {
    id: '20100',
    abbState: 'DE',
    state: 'Delaware',
    name: 'Dover',
    job: '1.0',
    yoyChange: '7.4',
    medianPrice: '316,100',
    hai: '99.9',
    growth: '11.7'
  },
  {
    id: '20500',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Durham-Chapel Hill',
    job: '3.2',
    yoyChange: '10.0',
    medianPrice: '458,500',
    hai: '88.6',
    growth: '27.5'
  },
  {
    id: '21300',
    abbState: 'NY',
    state: 'New York',
    name: 'Elmira',
    job: '33.3',
    yoyChange: '5.5',
    medianPrice: '156,600',
    hai: '200.2',
    growth: '-6.5'
  },
  {
    id: '21340',
    abbState: 'TX',
    state: 'Texas',
    name: 'El Paso',
    job: '1.8',
    yoyChange: '15.9',
    medianPrice: '241,500',
    hai: '94.8',
    growth: '6.2'
  },
  {
    id: '21500',
    abbState: 'PA',
    state: 'Pennsylvania',
    name: 'Erie',
    job: '24.0',
    yoyChange: '6.2',
    medianPrice: '166,800',
    hai: '185.2',
    growth: '-4.3'
  },
  {
    id: '21660',
    abbState: 'OR',
    state: 'Oregon',
    name: 'Eugene',
    job: '5.6',
    yoyChange: '9.8',
    medianPrice: '475,300',
    hai: '71.9',
    growth: '8.4'
  },
  {
    id: '22020',
    abbState: 'ND, MN',
    state: 'North Dakota, Minnesota',
    name: 'Fargo',
    job: '1.3',
    yoyChange: '8.3',
    medianPrice: '286,300',
    hai: '140.3',
    growth: '19.1'
  },
  {
    id: '22140',
    abbState: 'NM',
    state: 'New Mexico',
    name: 'Farmington',
    job: '-2.1',
    yoyChange: '8.3',
    medianPrice: '243,000',
    hai: '94.1',
    growth: '-5.6'
  },
  {
    id: '22180',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Fayetteville',
    job: '1.7',
    yoyChange: '15.7',
    medianPrice: '227,400',
    hai: '126.4',
    growth: '40.2'
  },
  {
    id: '22220',
    abbState: 'AR, MO',
    state: 'Arkansas, Missouri',
    name: 'Fayetteville-Springdale-Rogers',
    job: '2.3',
    yoyChange: '16.5',
    medianPrice: '328,400',
    hai: '102.2',
    growth: '17.6'
  },
  {
    id: '22500',
    abbState: 'SC',
    state: 'South Carolina',
    name: 'Florence',
    job: '-0.1',
    yoyChange: '13.4',
    medianPrice: '216,100',
    hai: '132.8',
    growth: '-3.3'
  },
  {
    id: '22540',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Fond du Lac',
    job: '2.3',
    yoyChange: '13.8',
    medianPrice: '200,600',
    hai: '179.1',
    growth: '2.2'
  },
  {
    id: '22660',
    abbState: 'CO',
    state: 'Colorado',
    name: 'Fort Collins',
    job: '3.9',
    yoyChange: '12.0',
    medianPrice: '602,700',
    hai: '71.6',
    growth: '18.7'
  },
  {
    id: '23060',
    abbState: 'IN',
    state: 'Indiana',
    name: 'Fort Wayne',
    job: '4.4',
    yoyChange: '9.5',
    medianPrice: '215,200',
    hai: '149.0',
    growth: '1.2'
  },
  {
    id: '23420',
    abbState: 'CA',
    state: 'California',
    name: 'Fresno',
    job: '4.2',
    yoyChange: '9.3',
    medianPrice: '410,000',
    hai: '70.4',
    growth: '7.5'
  },
  {
    id: '23540',
    abbState: 'FL',
    state: 'Florida',
    name: 'Gainesville',
    job: '3.1',
    yoyChange: '13.2',
    medianPrice: '349,500',
    hai: '84.8',
    growth: '30.0'
  },
  {
    id: '24020',
    abbState: 'NY',
    state: 'New York',
    name: 'Glens Falls',
    job: '1.2',
    yoyChange: '6.9',
    medianPrice: '257,200',
    hai: '131.2',
    growth: '-1.9'
  },
  {
    id: '24340',
    abbState: 'MI',
    state: 'Michigan',
    name: 'Grand Rapids-Wyoming',
    job: '6.2',
    yoyChange: '13.0',
    medianPrice: '309,600',
    hai: '119.3',
    growth: '40.0'
  },
  {
    id: '24580',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Green Bay',
    job: '4.7',
    yoyChange: '12.0',
    medianPrice: '265,800',
    hai: '138.1',
    growth: '6.5'
  },
  {
    id: '24660',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Greensboro-High Point',
    job: '3.4',
    yoyChange: '18.3',
    medianPrice: '278,900',
    hai: '106.2',
    growth: '6.6'
  },
  {
    id: '24860',
    abbState: 'SC',
    state: 'South Carolina',
    name: 'Greenville-Anderson-Mauldin',
    job: '3.5',
    yoyChange: '18.9',
    medianPrice: '335,400',
    hai: '91.6',
    growth: '45.3'
  },
  {
    id: '25060',
    abbState: 'MS',
    state: 'Mississippi',
    name: 'Gulfport-Biloxi-Pascagoulia',
    job: '0.8',
    yoyChange: '8.5',
    medianPrice: '214,000',
    hai: '132.1',
    growth: '66.8'
  },
  {
    id: '25180',
    abbState: 'MD, WV',
    state: 'Maryland, West Virginia',
    name: 'Hagerstown-Martinsburg',
    job: '0.8',
    yoyChange: '8.6',
    medianPrice: '275,500',
    hai: '120.6',
    growth: '11.0'
  },
  {
    id: '25420',
    abbState: 'PA',
    state: 'Pennsylvania',
    name: 'Harrisburg-Carlisle',
    job: '11.5',
    yoyChange: '7.3',
    medianPrice: '247,800',
    hai: '162.3',
    growth: '7.8'
  },
  {
    id: '25540',
    abbState: 'CT',
    state: 'Connecticut',
    name: 'Hartford-West Hartford-East Hartford',
    job: '13.6',
    yoyChange: '9.3',
    medianPrice: '344,100',
    hai: '133.1',
    growth: '-0.1'
  },
  {
    id: '26420',
    abbState: 'TX',
    state: 'Texas',
    name: 'Houston-The Woodlands-Sugar Land',
    job: '3.9',
    yoyChange: '12.8',
    medianPrice: '349,500',
    hai: '98.3',
    growth: '18.4'
  },
  {
    id: '26620',
    abbState: 'AL',
    state: 'Alabama',
    name: 'Huntsville',
    job: '1.3',
    yoyChange: '14.6',
    medianPrice: '327,500',
    hai: '130.8',
    growth: '18.2'
  },
  {
    id: '26900',
    abbState: 'IN',
    state: 'Indiana',
    name: 'Indianapolis-Carmel-Anderson',
    job: '3.8',
    yoyChange: '12.0',
    medianPrice: '301,400',
    hai: '119.9',
    growth: '19.8'
  },
  {
    id: '27140',
    abbState: 'MS',
    state: 'Mississippi',
    name: 'Jackson',
    job: '-0.9',
    yoyChange: '10.7',
    medianPrice: '246,000',
    hai: '118.1',
    growth: '7.6'
  },
  {
    id: '27260',
    abbState: 'FL',
    state: 'Florida',
    name: 'Jacksonville',
    job: '2.4',
    yoyChange: '17.4',
    medianPrice: '398,000',
    hai: '86.0',
    growth: '20.5'
  },
  {
    id: '28100',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Kankakee',
    job: '11.9',
    yoyChange: '2.1',
    medianPrice: '188,700',
    hai: '160.3',
    growth: '-6.2'
  },
  {
    id: '28140',
    abbState: 'MO, KS',
    state: 'Missouri, Kansas',
    name: 'Kansas City',
    job: '4.1',
    yoyChange: '11.0',
    medianPrice: '314,500',
    hai: '123.2',
    growth: '7.3'
  },
  {
    id: '28420',
    abbState: 'WA',
    state: 'Washington',
    name: 'Kennewick-Richland',
    job: '3.6',
    yoyChange: '13.2',
    medianPrice: '444,700',
    hai: '88.2',
    growth: '16.7'
  },
  {
    id: '28740',
    abbState: 'NY',
    state: 'New York',
    name: 'Kingston',
    job: '7.6',
    yoyChange: '7.8',
    medianPrice: '398,800',
    hai: '110.6',
    growth: '0.3'
  },
  {
    id: '28940',
    abbState: 'TN',
    state: 'Tennessee',
    name: 'Knoxville',
    job: '4.3',
    yoyChange: '13.9',
    medianPrice: '331,100',
    hai: '100.6',
    growth: '26.8'
  },
  {
    id: '29460',
    abbState: 'FL',
    state: 'Florida',
    name: 'Lakeland-Winter Haven',
    job: '0.7',
    yoyChange: '21.2',
    medianPrice: '340,000',
    hai: '83.3',
    growth: '23.6'
  },
  {
    id: '29620',
    abbState: 'MI',
    state: 'Michigan',
    name: 'Lansing-East Lansing',
    job: '22.4',
    yoyChange: '4.2',
    medianPrice: '210,100',
    hai: '162.6',
    growth: '16.2'
  },
  {
    id: '29820',
    abbState: 'NV',
    state: 'Nevada',
    name: 'Las Vegas-Henderson-Paradise',
    job: '4.6',
    yoyChange: '12.6',
    medianPrice: '463,500',
    hai: '68.0',
    growth: '16.4'
  },
  {
    id: '30460',
    abbState: 'KY',
    state: 'Kentucky',
    name: 'Lexington-Fayette',
    job: '4.6',
    yoyChange: '8.7',
    medianPrice: '249,400',
    hai: '144.2',
    growth: '8.1'
  },
  {
    id: '30700',
    abbState: 'NE',
    state: 'Nebraska',
    name: 'Lincoln',
    job: '3.2',
    yoyChange: '8.6',
    medianPrice: '275,800',
    hai: '138.3',
    growth: '11.7'
  },
  {
    id: '30780',
    abbState: 'AR',
    state: 'Alaska',
    name: 'Little Rock-North Little Rock-Conway',
    job: '4.4',
    yoyChange: '12.7',
    medianPrice: '211,700',
    hai: '145.4',
    growth: '5.9'
  },
  {
    id: '31084',
    abbState: 'CA',
    state: 'California',
    name: 'Los Angeles-Long Beach-Glendale',
    job: '18.3',
    yoyChange: '3.8',
    medianPrice: '893,200',
    hai: '37.7',
    growth: '0.4'
  },
  {
    id: '31140',
    abbState: 'KY, IN',
    state: 'Kentucky, Indiana',
    name: 'Louisville/Jefferson County',
    job: '6.9',
    yoyChange: '7.5',
    medianPrice: '263,800',
    hai: '123.1',
    growth: '-0.9'
  },
  {
    id: '31540',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Madison',
    job: '6.2',
    yoyChange: '9.1',
    medianPrice: '397,900',
    hai: '114.2',
    growth: '18.5'
  },
  {
    id: '31700',
    abbState: 'NH',
    state: 'New Hampshire',
    name: 'Manchester-Nashua',
    job: '6.8',
    yoyChange: '11.9',
    medianPrice: '469,000',
    hai: '100.1',
    growth: '5.6'
  },
  {
    id: '32820',
    abbState: 'TN, MS, AR',
    state: 'Tennessee, Mississippi, Arkansas',
    name: 'Memphis',
    job: '5.1',
    yoyChange: '8.9',
    medianPrice: '276,700',
    hai: '108.2',
    growth: '0.9'
  },
  {
    id: '33100',
    abbState: 'FL',
    state: 'Florida',
    name: 'Miami-Fort Lauderdale-West Palm Beach',
    job: '20.2',
    yoyChange: '16.3',
    medianPrice: '570,000',
    hai: '55.2',
    growth: '7.4'
  },
  {
    id: '33340',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Milwaukee-Waukesha-West Allis',
    job: '7.0',
    yoyChange: '7.6',
    medianPrice: '358,300',
    hai: '107.5',
    growth: '0.3'
  },
  {
    id: '33460',
    abbState: 'MN, WI',
    state: 'Minnesota, Wisconsin',
    name: 'Minneapolis-St. Paul-Bloomington',
    job: '8.2',
    yoyChange: '5.3',
    medianPrice: '381,100',
    hai: '124.2',
    growth: '11.2'
  },
  {
    id: '33660',
    abbState: 'AL',
    state: 'Alabama',
    name: 'Mobile',
    job: '0.6',
    yoyChange: '4.9',
    medianPrice: '213,300',
    hai: '128.4',
    growth: '4.4'
  },
  {
    id: '33860',
    abbState: 'AL',
    state: 'Alabama',
    name: 'Montgomery',
    job: '3.9',
    yoyChange: '4.2',
    medianPrice: '205,900',
    hai: '128.5',
    growth: '2.2'
  },
  {
    id: '34820',
    abbState: 'SC, NC',
    state: 'South Carolina, North Carolina',
    name: 'Myrtle Beach-Conway-North Myrtle Beach',
    job: '0.7',
    yoyChange: '21.1',
    medianPrice: '373,400',
    hai: '78.7',
    growth: '84.5'
  },
  {
    id: '34940',
    abbState: 'FL',
    state: 'Florida',
    name: 'Naples-Immokalee-Marco Island',
    job: '1.6',
    yoyChange: '16.7',
    medianPrice: '746,600',
    hai: '50.9',
    growth: '17.6'
  },
  {
    id: '34980',
    abbState: 'TN',
    state: 'Tennessee',
    name: 'Nashville-Davidson--Murfreesboro--Franklin',
    job: '4.0',
    yoyChange: '14.9',
    medianPrice: '408,300',
    hai: '90.7',
    growth: '24.3'
  },
  {
    id: '35300',
    abbState: 'CT',
    state: 'Connecticut',
    name: 'New Haven-Milford',
    job: '19.3',
    yoyChange: '12.8',
    medianPrice: '354,800',
    hai: '119.6',
    growth: '0.3'
  },
  {
    id: '35380',
    abbState: 'LA',
    state: 'Louisiana',
    name: 'New Orleans-Metairie',
    job: '7.7',
    yoyChange: '1.3',
    medianPrice: '278,900',
    hai: '108.6',
    growth: '5.9'
  },
  {
    id: '35620',
    abbState: 'NY, NJ, PA',
    state: 'New York, New Jersey, Pennsylvania',
    name: 'New York-Newark-Jersey City',
    job: '31.4',
    yoyChange: '6.9',
    medianPrice: '627,400',
    hai: '69.9',
    growth: '4.0'
  },
  {
    id: '35840',
    abbState: 'FL',
    state: 'Florida',
    name: 'North Port-Sarasota-Bradenton',
    job: '1.0',
    yoyChange: '23.8',
    medianPrice: '513,700',
    hai: '73.2',
    growth: '21.2'
  },
  {
    id: '35980',
    abbState: 'CT',
    state: 'Connecticut',
    name: 'Norwich-New London',
    job: '5.8',
    yoyChange: '10.4',
    medianPrice: '340,700',
    hai: '122.7',
    growth: '-1.7'
  },
  {
    id: '36100',
    abbState: 'FL',
    state: 'Florida',
    name: 'Ocala',
    job: '0.5',
    yoyChange: '18.8',
    medianPrice: '285,000',
    hai: '96.6',
    growth: '16.1'
  },
  {
    id: '36260',
    abbState: 'UT',
    state: 'Utah',
    name: 'Ogden-Clearfield',
    job: '2.3',
    yoyChange: '8.9',
    medianPrice: '479,200',
    hai: '82.9',
    growth: '27.6'
  },
  {
    id: '36420',
    abbState: 'OK',
    state: 'Oklahoma',
    name: 'Oklahoma City',
    job: '3.3',
    yoyChange: '18.5',
    medianPrice: '235,300',
    hai: '132.6',
    growth: '12.8'
  },
  {
    id: '36540',
    abbState: 'NE, IA',
    state: 'Nebraska, Iowa',
    name: 'Omaha-Council Bluffs',
    job: '4.3',
    yoyChange: '14.0',
    medianPrice: '278,500',
    hai: '151.1',
    growth: '11.1'
  },
  {
    id: '36740',
    abbState: 'FL',
    state: 'Florida',
    name: 'Orlando-Kissimmee-Sanford',
    job: '3.9',
    yoyChange: '16.4',
    medianPrice: '425,000',
    hai: '72.3',
    growth: '24.0'
  },
  {
    id: '36780',
    abbState: 'WI',
    state: 'Wisconsin',
    name: 'Oshkosh-Neenah',
    job: '3.4',
    yoyChange: '15.2',
    medianPrice: '226,900',
    hai: '160.0',
    growth: '2.3'
  },
  {
    id: '37340',
    abbState: 'FL',
    state: 'Florida',
    name: 'Palm Bay-Melbourne-Titusville',
    job: '2.0',
    yoyChange: '15.2',
    medianPrice: '368,500',
    hai: '87.5',
    growth: '13.4'
  },
  {
    id: '37460',
    abbState: 'FL',
    state: 'Florida',
    name: 'Panama City',
    job: '1.9',
    yoyChange: '20.5',
    medianPrice: '367,500',
    hai: '76.7',
    growth: '5.5'
  },
  {
    id: '37860',
    abbState: 'FL',
    state: 'Florida',
    name: 'Pensacola-Ferry Pass-Brent',
    job: '1.6',
    yoyChange: '13.0',
    medianPrice: '330,000',
    hai: '94.7',
    growth: '13.9'
  },
  {
    id: '37900',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Peoria',
    job: '29.2',
    yoyChange: '8.6',
    medianPrice: '148,200',
    hai: '227.3',
    growth: '4.6'
  },
  {
    id: '37980',
    abbState: 'PA, NJ, DE, MD',
    state: 'Pennsylvania, New Jersey, Delaware, Maryland',
    name: 'Philadelphia-Camden-Wilmington',
    job: '12.1',
    yoyChange: '7.5',
    medianPrice: '349,200',
    hai: '124.5',
    growth: '3.9'
  },
  {
    id: '38060',
    abbState: 'AZ',
    state: 'Arizona',
    name: 'Phoenix-Mesa-Scottsdale',
    job: '3.0',
    yoyChange: '10.4',
    medianPrice: '474,400',
    hai: '79.8',
    growth: '16.0'
  },
  {
    id: '38340',
    abbState: 'MA',
    state: 'Massachusetts',
    name: 'Pittsfield',
    job: '-4.6',
    yoyChange: '9.9',
    medianPrice: '332,800',
    hai: '98.4',
    growth: '-1.4'
  },
  {
    id: '38940',
    abbState: 'FL',
    state: 'Florida',
    name: 'Port St. Lucie',
    job: '1.6',
    yoyChange: '19.4',
    medianPrice: '410,000',
    hai: '78.7',
    growth: '17.7'
  },
  {
    id: '38860',
    abbState: 'ME',
    state: 'Maine',
    name: 'Portland-South Portland',
    job: '5.2',
    yoyChange: '11.8',
    medianPrice: '482,000',
    hai: '85.2',
    growth: '8.0'
  },
  {
    id: '38900',
    abbState: 'OR, WA',
    state: 'Oregon, Washington',
    name: 'Portland-Vancouver-Hillsboro',
    job: '10.5',
    yoyChange: '8.2',
    medianPrice: '594,300',
    hai: '73.6',
    growth: '11.0'
  },
  {
    id: '39300',
    abbState: 'RI, MA',
    state: 'Rhode Island, Massachusetts',
    name: 'Providence-Warwick',
    job: '9.1',
    yoyChange: '8.9',
    medianPrice: '453,800',
    hai: '88.5',
    growth: '4.7'
  },
  {
    id: '39460',
    abbState: 'FL',
    state: 'Florida',
    name: 'Punta Gorda',
    job: '0.5',
    yoyChange: '17.3',
    medianPrice: '381,100',
    hai: '74.7',
    growth: '21.4'
  },
  {
    id: '39580',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Raleigh',
    job: '2.6',
    yoyChange: '14.1',
    medianPrice: '460,500',
    hai: '95.6',
    growth: '24.5'
  },
  {
    id: '39740',
    abbState: 'PA',
    state: 'Pennsylvania',
    name: 'Reading',
    job: '12.7',
    yoyChange: '5.2',
    medianPrice: '236,500',
    hai: '153.0',
    growth: '4.0'
  },
  {
    id: '39900',
    abbState: 'NV',
    state: 'Nevada',
    name: 'Reno',
    job: '3.0',
    yoyChange: '6.7',
    medianPrice: '591,100',
    hai: '65.6',
    growth: '15.6'
  },
  {
    id: '40060',
    abbState: 'VA',
    state: 'Virginia',
    name: 'Richmond',
    job: '2.9',
    yoyChange: '8.2',
    medianPrice: '384,400',
    hai: '105.7',
    growth: '3.7'
  },
  {
    id: '40140',
    abbState: 'CA',
    state: 'California',
    name: 'Riverside-San Bernardino-Ontario',
    job: '6.9',
    yoyChange: '8.2',
    medianPrice: '567,000',
    hai: '64.8',
    growth: '8.1'
  },
  {
    id: '40380',
    abbState: 'NY',
    state: 'New York',
    name: 'Rochester',
    job: '5.8',
    yoyChange: '8.4',
    medianPrice: '224,000',
    hai: '166.4',
    growth: '2.8'
  },
  {
    id: '40420',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Rockford',
    job: '29.6',
    yoyChange: '4.9',
    medianPrice: '174,000',
    hai: '180.4',
    growth: '-3.5'
  },
  {
    id: '40900',
    abbState: 'CA',
    state: 'California',
    name: 'Sacramento--Roseville--Arden-Arcade',
    job: '4.1',
    yoyChange: '4.5',
    medianPrice: '535,000',
    hai: '79.8',
    growth: '10.8'
  },
  {
    id: '41180',
    abbState: 'MO, IL',
    state: 'Missouri, Illinois',
    name: 'St. Louis',
    job: '6.2',
    yoyChange: '9.0',
    medianPrice: '256,800',
    hai: '145.8',
    growth: '-0.3'
  },
  {
    id: '41420',
    abbState: 'OR',
    state: 'Oregon',
    name: 'Salem',
    job: '1.9',
    yoyChange: '8.8',
    medianPrice: '464,000',
    hai: '72.6',
    growth: '10.5'
  },
  {
    id: '41620',
    abbState: 'UT',
    state: 'Utah',
    name: 'Salt Lake City',
    job: '4.2',
    yoyChange: '12.1',
    medianPrice: '561,200',
    hai: '70.1',
    growth: '10.2'
  },
  {
    id: '41700',
    abbState: 'TX',
    state: 'Texas',
    name: 'San Antonio-New Braunfels',
    job: '4.6',
    yoyChange: '13.9',
    medianPrice: '342,700',
    hai: '98.3',
    growth: '18.5'
  },
  {
    id: '41740',
    abbState: 'CA',
    state: 'California',
    name: 'San Diego-Carlsbad',
    job: '12.4',
    yoyChange: '5.9',
    medianPrice: '900,000',
    hai: '47.8',
    growth: '4.6'
  },
  {
    id: '41860',
    abbState: 'CA',
    state: 'California',
    name: 'San Francisco-Oakland-Hayward',
    job: '29.2',
    yoyChange: '-3.7',
    medianPrice: '1,300,000',
    hai: '44.7',
    growth: '5.3'
  },
  {
    id: '41940',
    abbState: 'CA',
    state: 'California',
    name: 'San Jose-Sunnyvale-Santa Clara',
    job: '18.3',
    yoyChange: '2.3',
    medianPrice: '1,688,000',
    hai: '40.2',
    growth: '4.6'
  },
  {
    id: '42660',
    abbState: 'WA',
    state: 'Washington',
    name: 'Seattle-Tacoma-Bellevue',
    job: '12.4',
    yoyChange: '4.6',
    medianPrice: '741,300',
    hai: '71.0',
    growth: '14.6'
  },
  {
    id: '42680',
    abbState: 'FL',
    state: 'Florida',
    name: 'Sebastian-Vero Beach',
    job: '1.7',
    yoyChange: '13.5',
    medianPrice: '374,700',
    hai: '72.8',
    growth: '17.8'
  },
  {
    id: '43340',
    abbState: 'LA',
    state: 'Louisiana',
    name: 'Shreveport-Bossier City',
    job: '3.6',
    yoyChange: '14.8',
    medianPrice: '220,600',
    hai: '119.6',
    growth: '-3.6'
  },
  {
    id: '43620',
    abbState: 'SD',
    state: 'South Dakota',
    name: 'Sioux Falls',
    job: '4.2',
    yoyChange: '15.6',
    medianPrice: '325,300',
    hai: '121.7',
    growth: '21.6'
  },
  {
    id: '43780',
    abbState: 'IN, MI',
    state: 'Indiana, Michigan',
    name: 'South Bend-Mishawaka',
    job: '14.4',
    yoyChange: '11.1',
    medianPrice: '207,800',
    hai: '159.0',
    growth: '1.6'
  },
  {
    id: '43900',
    abbState: 'SC',
    state: 'South Carolina',
    name: 'Spartanburg',
    job: '2.1',
    yoyChange: '16.8',
    medianPrice: '275,600',
    hai: '110.9',
    growth: '17.1'
  },
  {
    id: '44060',
    abbState: 'WA',
    state: 'Washington',
    name: 'Spokane-Spokane Valley',
    job: '3.1',
    yoyChange: '5.8',
    medianPrice: '422,500',
    hai: '81.6',
    growth: '25.3'
  },
  {
    id: '44100',
    abbState: 'IL',
    state: 'Illinois',
    name: 'Springfield',
    job: '16.5',
    yoyChange: '5.3',
    medianPrice: '167,400',
    hai: '231.6',
    growth: '-1.9'
  },
  {
    id: '44140',
    abbState: 'MA',
    state: 'Massachusetts',
    name: 'Springfield',
    job: '26.6',
    yoyChange: '8.6',
    medianPrice: '324,600',
    hai: '109.7',
    growth: '0.3'
  },
  {
    id: '44180',
    abbState: 'MO',
    state: 'Missouri',
    name: 'Springfield',
    job: '3.8',
    yoyChange: '15.0',
    medianPrice: '235,100',
    hai: '141.2',
    growth: '9.5'
  },
  {
    id: '45060',
    abbState: 'NY',
    state: 'New York',
    name: 'Syracuse',
    job: '21.8',
    yoyChange: '10.7',
    medianPrice: '208,100',
    hai: '170.1',
    growth: '-0.6'
  },
  {
    id: '45220',
    abbState: 'FL',
    state: 'Florida',
    name: 'Tallahassee',
    job: '4.6',
    yoyChange: '14.4',
    medianPrice: '319,000',
    hai: '108.0',
    growth: '4.5'
  },
  {
    id: '45300',
    abbState: 'FL',
    state: 'Florida',
    name: 'Tampa-St. Petersburg-Clearwater',
    job: '4.7',
    yoyChange: '18.8',
    medianPrice: '405,100',
    hai: '81.7',
    growth: '14.0'
  },
  {
    id: '45780',
    abbState: 'OH',
    state: 'Ohio',
    name: 'Toledo',
    job: '17.1',
    yoyChange: '4.8',
    medianPrice: '175,200',
    hai: '199.2',
    growth: '-0.9'
  },
  {
    id: '45820',
    abbState: 'KS',
    state: 'Kansas',
    name: 'Topeka',
    job: '7.2',
    yoyChange: '9.5',
    medianPrice: '188,900',
    hai: '173.7',
    growth: '-0.7'
  },
  {
    id: '45940',
    abbState: 'NJ',
    state: 'New Jersey',
    name: 'Trenton',
    job: '27.9',
    yoyChange: '7.0',
    medianPrice: '398,000',
    hai: '120.6',
    growth: '5.1'
  },
  {
    id: '46060',
    abbState: 'AZ',
    state: 'Arizona',
    name: 'Tucson',
    job: '2.2',
    yoyChange: '11.1',
    medianPrice: '376,100',
    hai: '85.4',
    growth: '6.3'
  },
  {
    id: '46140',
    abbState: 'OK',
    state: 'Oklahoma',
    name: 'Tulsa',
    job: '4.4',
    yoyChange: '7.7',
    medianPrice: '246,500',
    hai: '125.4',
    growth: '8.1'
  },
  {
    id: '46520',
    abbState: 'HI',
    state: 'Hawaii',
    name: 'Urban Honolulu',
    job: '25.1',
    yoyChange: '7.6',
    medianPrice: '1,127,400',
    hai: '39.6',
    growth: '3.9'
  },
  {
    id: '47260',
    abbState: 'VA, NC',
    state: 'Virginia, North Carolina',
    name: 'Virginia Beach-Norfolk-Newport News',
    job: '5.7',
    yoyChange: '12.9',
    medianPrice: '327,300',
    hai: '115.3',
    growth: '7.7'
  },
  {
    id: '47900',
    abbState: 'DC, VA, MD, WV',
    state: 'Washington, Virginia, Maryland, West Virginia',
    name: 'Washington-Arlington-Alexandria',
    job: '5.3',
    yoyChange: '6.0',
    medianPrice: '581,300',
    hai: '96.5',
    growth: '11.5'
  },
  {
    id: '47940',
    abbState: 'IA',
    state: 'Iowa',
    name: 'Waterloo-Cedar Falls',
    job: '6.9',
    yoyChange: '9.6',
    medianPrice: '174,500',
    hai: '210.5',
    growth: '0.0'
  },
  {
    id: '48620',
    abbState: 'KS',
    state: 'Kansas',
    name: 'Wichita',
    job: '6.4',
    yoyChange: '11.9',
    medianPrice: '220,200',
    hai: '144.3',
    growth: '3.7'
  },
  {
    id: '48660',
    abbState: 'TX',
    state: 'Texas',
    name: 'Wichita Falls',
    job: '14.6',
    yoyChange: '12.1',
    medianPrice: '176,400',
    hai: '186.6',
    growth: '0.0'
  },
  {
    id: '48900',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Wilmington',
    job: '2.0',
    yoyChange: '10.8',
    medianPrice: '411,100',
    hai: '90.3',
    growth: '-21.1'
  },
  {
    id: '49180',
    abbState: 'NC',
    state: 'North Carolina',
    name: 'Winston-Salem',
    job: '1.9',
    yoyChange: '17.3',
    medianPrice: '283,000',
    hai: '107.6',
    growth: '41.4'
  },
  {
    id: '49340',
    abbState: 'MA, CT',
    state: 'Massachusetts, Connecticut',
    name: 'Worcester',
    job: '5.2',
    yoyChange: '11.4',
    medianPrice: '431,000',
    hai: '101.2',
    growth: '22.1'
  },
  {
    id: '49420',
    abbState: 'WA',
    state: 'Washington',
    name: 'Yakima',
    job: '7.0',
    yoyChange: '6.4',
    medianPrice: '359,200',
    hai: '79.8',
    growth: '3.6'
  },
  {
    id: '49620',
    abbState: 'PA',
    state: 'Pennsylvania',
    name: 'York-Hanover',
    job: '6.7',
    yoyChange: '5.1',
    medianPrice: '245,400',
    hai: '147.9',
    growth: '5.0'
  },
  {
    id: '49660',
    abbState: 'OH, PA',
    state: 'Ohio, Pennsylvania',
    name: 'Youngstown-Warren-Boardman',
    job: '3.9',
    yoyChange: '5.9',
    medianPrice: '148,000',
    hai: '197.7',
    growth: '-4.4'
  }
];

export default dataByArea;
